bq.global.runCounter = function() {
    window.onload = function() {
        var count = $('.counter');
        var span = count.children('span.number');

        count.css('display', 'block');

        span.counterUp({
            time: 2000
        });
    }
};


bq.init.push(bq.global.runCounter);
